import React from 'react'
import classnames from 'classnames'
import { Button } from '../../../..'

import styles from './StepFooterButton.module.scss'

export interface StepFooterProps {
  disableButton?: boolean
  children: React.ReactNode
  onClick?: () => void
  loading?: boolean
  optIn?: boolean
  type?: 'button' | 'submit' | 'reset'
  form?: string
}

export const StepFooterButton = ({
  children,
  disableButton,
  onClick,
  loading,
  optIn,
  form,
  type = 'button'
}: StepFooterProps) => {
  return (
    <div>
      <Button
        fullWidth
        className={classnames(styles.nextButton, optIn && styles.optIn, disableButton && styles.disabled)}
        onClick={onClick}
        disabled={disableButton}
        loading={loading}
        primary
        type={type}
        form={form}
      >
        {children}
      </Button>
    </div>
  )
}
